import { ActionTree } from "vuex";
import { LocalStorage } from "quasar";
import { StateInterface } from "src/store";
import { ChatStateInterface } from "./state";
import API from "src/services/api/api";
import Utils from "src/services/helpers/utils";
import EventBus from "src/services/event-bus";
import LocalDb from "src/services/db";
import ma_objects from "src/modules/ma/classes/ma_objects";
import { EventItem } from "../../models";

const actions: ActionTree<ChatStateInterface, StateInterface> = {
  async init({ state, dispatch, commit, rootGetters }) {
    const db = await LocalDb;
    const messages = await db.messages.getMessages();
    commit("init", messages);
    if (
      rootGetters["settings/allSettings"].helloMessageEnabled ||
      !state.messages.length
    ) {
      dispatch("initHello");
    }
  },

  async resetDialog(context) {
    context.commit("init", []);
    await context.dispatch("deleteMessages");
    return Promise.resolve();
  },

  async initHello(context) {
    // console.log("initHello");
    const initReaction =
      context.rootGetters["settings/fullSettings"].initReaction;
    if (initReaction) {
      const initReactionRef = ma_objects.ref2str(initReaction.defaultValueRef);
      if (initReactionRef) {
        const session_guid = LocalStorage.getItem("dialogId") as string;
        const events = (
          await API.cf.make_reaction(session_guid, initReactionRef)
        )?.events;
        for (let i = 0; i < events.length; i++) {
          const message = EventItem.toOldMessage(events[i]);
          context.dispatch("addMessage", {
            ...message,
            isEventItem: true,
          });
        }
      }
    }
  },

  push_message(context, message) {
    // console.log("push_message message", message);
    context.commit("push_message", message);
    // обработка вложений
    const settings = context.rootGetters["settings/allSettings"];
    const autoOpenLinks = settings.autoOpenLinks;
    const openLinksNewTab = settings.openLinksNewTab;
    const autoOpenVideo = settings.autoOpenVideo;
    const autoOpenGame = settings.autoOpenGame;
    if (message && message.state) {
      const url = message.state.goto_url;
      if (url && autoOpenLinks) {
        if (openLinksNewTab) {
          window.open(url, "_blank");
        } else {
          location.href = url;
        }
      } else {
        if (message?.state?.files?.length) {
          const files = message.state.files;
          if (
            (files[0].type == "video" && autoOpenVideo) ||
            (files[0].type == "game" && autoOpenGame)
          ) {
            EventBus.$emit("clickFile", files[0]);
          }
        }
      }
    }
  },

  async addMessage(
    context,
    {
      guid,
      text,
      clearText,
      yandexText,
      sent,
      audio_guid,
      type,
      s,
      state,
      at,
      isEventItem,
      payload,
    }
  ) {
    const state_any = s || state;
    const message = {
      id: undefined,
      guid,
      key: guid || Utils.generateGuid(),
      text,
      clearText,
      yandexText,
      sent,
      audio_guid,
      type: type || "message",
      s: state_any,
      state: state_any,
      at,
      stamp: at || new Date(),
      isEventItem,
      payload,
    };
    if (message.type == "init") return;
    // TODO: удалить после отказа от proceedQuestion
    //#region дублируем сообщение в новое хранилище
    if (!message.isEventItem) {
      const event = EventItem.fromOldMessage(message);
      context.dispatch(
        "events/pushEvents",
        {
          session_guid: event.session_guid,
          events: [event],
        },
        { root: true }
      );
    }
    //#endregion
    const db = await LocalDb;
    message.id = await db.messages.addMessage(message);
    if (message.sent === false) {
      (window as any).ws?.send_mark_is_read(message.key);
    }
    await context.dispatch("push_message", message);

    return Promise.resolve();
  },

  loadPreviousMessages({ state, commit }) {
    return new Promise((resolve) => {
      const messageId = state.messages.length == 0 ? 0 : state.messages[0].id;
      LocalDb.then((db) => {
        db.messages.getMessages(messageId).then((messages: any) => {
          commit("addPreviousMessages", messages);
          resolve(messages.length);
        });
      });
    });
  },

  async deleteMessages({ commit }) {
    commit("deleteMessages");
    const db = await LocalDb;
    await db.messages.clearMessages();
  },

  updateMessage({ commit }, message) {
    commit("updateMessage", message);
  },

  updateMessageRecognizeAgain(context, { message, recognizeAgain }) {
    context.commit("updateMessageRecognizeAgain", { message, recognizeAgain });
    context.dispatch("updateMessage", message);
  },

  getCountAudio({}) {
    return LocalDb.then((db) => db.audio.getCountAudio());
  },

  deleteAudios({ commit }, date) {
    commit("deleteAudios", date);
  },

  async setAnswerRate(context, { message, rate }) {
    const chatSenderType =
      context.rootGetters["settings/allSettings"].chatSenderType;
    if (chatSenderType == "proceedQuestion") {
      API.cf
        .set_message_rate({ guid: message.guid, rate: rate })
        .then(() => context.commit("setAnswerRate", { message, rate }));
    } else {
      await context.dispatch(
        "events/rateEvent",
        {
          event_guid: message.guid,
          rate: rate,
        },
        { root: true }
      );
      context.commit("setAnswerRate", { message, rate });
    }

    return Promise.resolve();
  },
};

export default actions;
